import React, {useEffect, useState} from 'react';
import {Box, Button, Grid, Typography} from '@mui/material';
import {RecommendProps} from '../CreateRecommend/RecommendSourceDestination/validators';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {useResetReccs} from '../CreateRecommend/RecommendSourceDestination/useResetReccs';
import {actionFieldsType} from './actionFields';
import AutoField, {ActionType} from '../../../components/AutoForm/AutoFieldNew';
import {useRecommendContext} from '../CreateRecommend/CreateRecommendHelpers';
import {ScrollableModal} from '../../../components/Common/ScrollableModal';
import {loadActionNotes, useLoadActionNotes} from '../hooks/actionHooks';

export {loadActionNotes, useLoadActionNotes};

export const RecommendsAction: React.FC<RecommendProps> = () => {
  useResetReccs(OVRecommendActionEnum.ACTION);
  const {loaded} = useLoadActionNotes();
  const [showActionWarning, setActionWarning] = useState(true);
  return (
    <>
      <ScrollableModal open={showActionWarning}>
        <Box bgcolor="white" padding={4}>
          <Typography color="primary" variant="h6">
            An “action” requirement should only be used for recommendations that do NOT
            relate to a plan.
          </Typography>
          <Box mt={2} />
          <Typography color="primary" variant="body1">
            It should be used for things such as advice to set up a Will or POA. All
            initial requirements should be added under the appropriate recommendation
            type.
          </Typography>
          <Box mt={4} />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setActionWarning(false);
            }}
          >
            Ok
          </Button>
        </Box>
      </ScrollableModal>
      <Box mt={4} bgcolor="white" padding={4} paddingTop={3} paddingBottom={5} mb={4}>
        <Typography variant="h5">Action Based Requirements</Typography>
        <Box mt={4} />
        <Grid container spacing={2}>
          <Grid xs={12} md={8} lg={6}>
            <AutoField
              field={{
                type: ActionType.text,
                multiline: true,
                minRows: 14,
                fullWidth: true,
                id: 'action.note',
                label: 'Action notes',
                charLimit: 8000,
                showCounter: true,
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
